module.exports = __webpack_public_path__ + "assets/img/icon-satellite-map-blue.fd2ca9bf.png";